import { createSelector } from '@reduxjs/toolkit';

export const selectUtmSource = (state) => state?.utmParameters?.utmSource;
export const selectUtmMedium = (state) => state?.utmParameters?.utmMedium;
export const selectUtmCampaign = (state) => state?.utmParameters?.utmCampaign;
export const selectUtmTerm = (state) => state?.utmParameters?.utmTerm;
export const selectUtmContent = (state) => state?.utmParameters?.utmContent;
export const selectEntranceUrl = (state) => state?.utmParameters?.entranceUrl;
export const selectGoogleClickId = (state) => state?.utmParameters?.googleClickId;
export const selectHttpReferer = (state) => state?.utmParameters?.httpReferer;
export const selectRefer = (state) => state?.utmParameters?.refer;

/**
 * Returns true if the map is fetching results from the server.
 * @param state - The state of the Redux store.
 */
export const isLoading = (state) => state?.utmParameters?.isLoading;

export const selectUtmTrackingCommonProperties = createSelector(selectRefer, (refer) => ({ refer }));
